import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Tabs, 
  Tab, 
  Paper 
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import MafiaSimulator from '../components/simulator/MafiaSimulator';
import MaterialsList from '../components/study/MaterialsList';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`study-tabpanel-${index}`}
      aria-labelledby={`study-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `study-tab-${index}`,
    'aria-controls': `study-tabpanel-${index}`,
  };
}

const Study: React.FC = () => {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  // Parse tab from URL path
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/study/materials') {
      setValue(0);
    } else if (path === '/study/simulator') {
      setValue(1);
    }
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    
    // Update URL based on selected tab
    if (newValue === 0) {
      navigate('/study/materials');
    } else if (newValue === 1) {
      navigate('/study/simulator');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
        Study
      </Typography>
      
      <Paper elevation={3} sx={{ borderRadius: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={value} 
            onChange={handleChange} 
            aria-label="study tabs"
            sx={{ 
              '& .MuiTabs-indicator': {
                backgroundColor: 'secondary.main',
              }
            }}
          >
            <Tab label="Materials" {...a11yProps(0)} />
            <Tab label="Simulator" {...a11yProps(1)} />
          </Tabs>
        </Box>
        
        <TabPanel value={value} index={0}>
          <MaterialsList />
        </TabPanel>
        
        <TabPanel value={value} index={1}>
          <MafiaSimulator />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default Study;